import { setupDisturbancePanel } from "./modules/disturbance-panel";
import { setupNavigationSubMenus } from "./modules/navigation-sub-menus";
import { setupCategorySubMenus } from "./modules/category-sub-menus";
import { setupMenus } from "./modules/setup-menus";

document.addEventListener('DOMContentLoaded', () => {
  setupMenus();
  setupNavigationSubMenus();
  setupCategorySubMenus();
  setupDisturbancePanel();

  $(".close").on('click', function () {
    $('#lang-select').slideUp(200);
  });

  if ($(window).width() <= 666) {
    $("#logotype").insertAfter("#top_navigation");
  }

  $(document).ready(function () {
    $('.cat-item a').attr('aria-label', 'Kategoriarkiv');
  });

  //---------------------------------------------------------------
  // ANPASSAD HÖJD
  //---------------------------------------------------------------

  let highestBox = 0;
  $('.arkiv .cat_nav .info ul > li').each(function () {
    if ($(this).height() > highestBox) {
      highestBox = $(this).height();
    }
  });
  $('.arkiv .cat_nav .info ul > li').height(highestBox);
});
